import {
  NBS_API_GET_MUTUAL_LIKES_SUCCESS,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS,
  RESET_GET_MUTUAL_LIKES_OPENED,
  RESET_GET_MUTUAL_LIKES_SEEN,
} from '../../constants/actions';

const initialState = {
  data: [],
  lastUserId: '',
  end: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_MUTUAL_LIKES_SUCCESS:
      const currentState = { ...state };
      const { matches } = action.response;
      let lastUserId, end;

      if (Object.prototype.hasOwnProperty.call(action.response, 'end')) {
        lastUserId =
          action.response.end || !matches || !matches.length
            ? ''
            : matches[matches.length - 1].user_id;
        end = action.response.end;
      } else {
        lastUserId = '';
        end = true;
      }
      return {
        lastUserId,
        end,
        data: action.startOver
          ? [...matches]
          : [...currentState.data, ...matches].reduce(
              (r, i) =>
                !r.some((j) => i.user_id === j.user_id) ? [...r, i] : r,
              []
            ), // filter data, remove duplicates
      };
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state.data];
      const newUsers = currentUsers.filter(
        (user) => user.user_id !== action.userId
      );
      return { ...state, data: newUsers };
    case RESET_GET_MUTUAL_LIKES_OPENED:
      const newData = [];
      state.data.forEach((user) => {
        if (user.user_id === action.userId) {
          user.unopened = false;
        }
        newData.push(user);
      });
      return { ...state, data: newData };
    case RESET_GET_MUTUAL_LIKES_SEEN:
      const newListData = [];
      state.data.forEach((user) => {
        user.unseen = false;
        newListData.push(user);
      });
      return { ...state, data: newListData };
    default:
      return state;
  }
}
